import { createSelector, createSlice } from '@reduxjs/toolkit';

import { getSessionStorage, removeLocalStorage, setSessionStorage } from '../../common/storage';

const initialState = {
	businesses: [],
	activeBusiness: JSON.parse(getSessionStorage('act_bsn')) || {},
	activeStore: JSON.parse(getSessionStorage('act_str')) || {},
};

const businessSlice = createSlice({
	name: 'business',
	initialState,
	reducers: {
		setBusinessState: (state, action) => {
			const businesses = action.payload;

			let actBsn = state.activeBusiness;
			let savedBsn = JSON.parse(getSessionStorage('act_bsn'));

			let actStr = state.activeStore;
			let savedStr = JSON.parse(getSessionStorage('act_str'));

			if (savedBsn && businesses.find((b) => b._id === savedBsn._id)) {
				actBsn = savedBsn;
			} else if (businesses[0]) {
				actBsn = { _id: businesses[0]._id, title: businesses[0].title, logo: businesses[0].logo };
			}

			let savedBusiness = businesses.find((b) => b._id === savedBsn?._id);
			let savedStore = savedBusiness?.stores.find((s) => s._id === savedStr._id);

			// savedStrt and savedBusiness are not null
			if (savedStr && savedBusiness && savedStore) {
				actStr = savedStr;
				// savedBusiness is not null but savedStore is null get the first Store
			} else if (savedBusiness && savedBusiness.stores[0]) {
				actStr = { _id: savedBusiness.stores[0]._id, title: savedBusiness.stores[0].title };
				// savedBusiness is not null but savedStore is null and there is no store
			} else if (savedBusiness && savedBusiness.stores.length === 0) {
				actStr = {};
			} else {
				// savedBusiness is null get the first business and first store
				actStr = { _id: businesses[0]?.stores[0]?._id, title: businesses[0]?.stores[0]?.title };
			}

			state.activeStore = actStr;
			state.activeBusiness = actBsn;
			state.businesses = businesses;

			setSessionStorage('act_bsn', JSON.stringify(actBsn));
			setSessionStorage('act_str', JSON.stringify(actStr));
		},
		addBusiness: (state, action) => {
			const business = action.payload;

			state.businesses.push(business);
		},
		deleteBusiness: (state, action) => {
			const businessId = action.payload.id;
			state.businesses = state.businesses.filter((b) => b._id !== businessId);
		},
		setActiveBusiness: (state, action) => {
			const { business } = action.payload;

			if (state.activeBusiness._id !== business._id) {
				state.activeBusiness = business;
				setSessionStorage('act_bsn', JSON.stringify(business));
			}
		},
		setActiveBusinessStore: (state, action) => {
			const { store, business } = action.payload;

			if (state.activeBusiness._id !== business._id) {
				state.activeBusiness = business;
				setSessionStorage('act_bsn', JSON.stringify(business));
			}
			if (store != null) {
				state.activeStore = store;
				setSessionStorage('act_str', JSON.stringify(store));
			} else {
				removeLocalStorage('act_str');
			}
		},
		setActiveStore: (state, action) => {
			if (action.payload == null) {
				removeLocalStorage('act_str');
				state.activeStore = {};
				return;
			}
			const { _id, title } = action.payload;

			state.activeStore = { _id, title };
			setSessionStorage('act_str', JSON.stringify({ _id, title }));
		},
		updateStoreInBusiness: (state, action) => {
			const { storeId, updates } = action.payload;
			const business = state.businesses.find((b) => b._id === state.activeBusiness._id);
			if (business) {
				const store = business.stores.find((s) => s._id === storeId);
				if (store) {
					Object.assign(store, updates);
					// If this is the active store, update it as well
					if (state.activeStore._id === storeId) {
						state.activeStore = { ...state.activeStore, ...updates };
						setSessionStorage('act_str', JSON.stringify(state.activeStore));
					}
				}
			}
		},
		removeStoreFromBusiness: (state, action) => {
			const { storeId } = action.payload;
			const business = state.businesses.find((b) => b._id === state.activeBusiness._id);
			if (business) {
				business.stores = business.stores.filter((s) => s._id !== storeId);
				// If this was the active store, clear it
				if (state.activeStore._id === storeId) {
					state.activeStore = business.stores[0] || {};
					if (state.activeStore._id) {
						setSessionStorage('act_str', JSON.stringify(state.activeStore));
					} else {
						removeLocalStorage('act_str');
					}
				}
			}
		},
	},
});

export const {
	setBusinessState,
	setActiveStore,
	setActiveBusinessStore,
	setActiveBusiness,
	addBusiness,
	deleteBusiness,
	updateStoreInBusiness,
	removeStoreFromBusiness,
} = businessSlice.actions;

export const selectBusinesses = ({ business }) => business.businesses;
export const selectActiveBusiness = ({ business }) => business.activeBusiness;
export const selectActiveStore = ({ business }) => business.activeStore;

export const selectMemoBusinessStores = (bid) =>
	createSelector([selectBusinesses], (businesses) => {
		const selectedBusiness = businesses.find((b) => b._id === bid);

		return selectedBusiness?.stores || [];
	});

// Add this new thunk action creator
export const deleteBusinessAndUpdateActive = (business) => (dispatch, getState) => {
	dispatch(deleteBusiness({ id: business._id }));

	const state = getState();
	const businesses = state.business.businesses;

	if (business.id === state.business.activeBusiness._id && businesses.length > 0) {
		const firstBusiness = businesses[0];
		const firstStore = firstBusiness.stores[0];
		dispatch(
			setActiveBusinessStore({
				business: firstBusiness,
				store: firstStore,
			})
		);
	}
};

export default businessSlice.reducer;
